module.exports = __webpack_public_path__ + "img/y-262.ab9f934b.png";